import { render, staticRenderFns } from "./Marunage.vue?vue&type=template&id=0efeea2a&scoped=true&"
import script from "./Marunage.vue?vue&type=script&lang=js&"
export * from "./Marunage.vue?vue&type=script&lang=js&"
import style0 from "./Marunage.vue?vue&type=style&index=0&id=0efeea2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efeea2a",
  null
  
)

export default component.exports